import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { fetchUnsurCode, fetchKategori } from "../../api/kugi";
import TablePropertyType from "../../components/Kugi/tablePropertyType";
import BorderColor from "@material-ui/icons/BorderColor";
import ArrowBack from "@material-ui/icons/ArrowBackIos";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Config from "../../config/";
import {
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
} from "@material-ui/core";
import { uploadRdf, prediketList } from "../../api/kugi";
import { toast, ToastContainer } from "react-toastify";
import BlockUi from "react-block-ui";
import "react-toastify/dist/ReactToastify.css";
import { TextField } from "@material-ui/core";
import TableUpload from "./TableUpload";

// const override = css`
//   position: absolute;
//   top: 50%;
//   left: 40%;
//   margin: 0 auto;
// `;

class UploadRDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      openWarning: false,
      alert: false,
      alertError: false,
      fileUpload: null,
      predikatList: [{ namaprediket: "ONTOLOGI", labelprediket: "ontologi" }],
      predikatFile: [],
      error: false,
      loading: false,
      fileName: [],
    };
  }

  componentWillMount() {
    if (localStorage.getItem("token") == null) {
      console.log(localStorage.getItem("token"));
      this.props.history.push(`/login`);
    }
    prediketList().then((res) => {
      res.data.map((item) => {
        this.setState({
          predikatList: [...this.state.predikatList, item],
        });
      });
    });
  }

  handleFiles = async (e) => {
    await this.handleArray(e);
    this.state.files.map((item) => {
      this.setState({
        // predikatFile: [...this.state.predikatFile, "memilikiADMIN1"],
        fileName: [...this.state.fileName, item.name],
      });
    });
  };

  handleArray = (e) => {
    if (e.target.files) {
      this.setState({
        files: Array.from(e.target.files),
        fileUpload: e.target.files,
      });
    }
  };

  handleChange = (e, index) => {
    let tempArray = this.state.predikatFile;
    tempArray[index] = e.target.value;
    this.setState({ predikatFile: tempArray });
  };

  handleChangeName = (e, index) => {
    let tempName = this.state.fileName;
    tempName[index] = e.target.value;
    this.setState({ fileName: tempName });
  };

  handelSubmit = () => {
    if (this.state.files.length !== this.state.predikatFile.length) {
      this.setState({ error: true });
    } else this.setState({ openWarning: true });
  };

  handleError = (e) => {
    if (this.state.error) if (!e) return true;
    return false;
  };

  handlePredikat = (e) => {
    if (e !== "ONTOLOGI") {
      const temp = e.split("#");
      return temp[1];
    } else {
      return e;
    }
  };

  handleSuccess = (result) => {
    if (result) {
      toast.success("Successfuly upload file", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error("Error uploading file", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleUpload = () => {
    this.setState({ loading: true });
    this.state.files.map((item, index) => {
      // this.setState({ alert: false });
      uploadRdf(
        item,
        this.state.predikatFile[index],
        this.state.fileName[index]
      )
        .then((res) => {
          this.setState({ loading: false });
          this.handleSuccess(true)
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.setState({ loading: false });
          this.handleSuccess(false)
        });
    });
    this.setState({ openWarning: false, files: [], predikatFile: [] });
  };

  handleLoadingTrue = () => {
    this.setState({ loading: true });
  };

  handleLoadingFlase = () => {
    this.setState({ loading: false });
  };

  render() {
    return (
      <AUX>
        <BlockUi
          blocking={this.state.loading}
          color="#497ac2"
          message="Loading..."
        >
          <section className="sections" style={{ paddingTop: "5%" }}>
            <div className="container">
              <h2>Upload RDF</h2>
              <h5>Ketik button dibawah untuk memilih berkas yang diinginkan</h5>
              <Grid container style={{ alignItems: "center" }}>
                <Grid item xs={12}>
                  <form>
                    <input
                      multiple
                      type="file"
                      id="fileRDf"
                      name="fileRDF"
                      onChange={(e) => this.handleFiles(e)}
                      style={{ display: "none" }}
                    />
                    <label
                      htmlFor="fileRDf"
                      style={{
                        backgroundColor: "#497ac2",
                        color: "#FFF",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      Pilih berkas
                    </label>
                  </form>
                </Grid>
                <Grid xs={12}>
                  {this.state.files.length === 0 ? null : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <h5>
                        File yang dipilih adalah: <br />
                      </h5>
                      <br />
                      {this.state.files.map((item, index) => (
                        <React.Fragment>
                          <Grid
                            container
                            spacing={3}
                            justify="center"
                            alignItems="center"
                          >
                            <Grid xs={1}>{index + 1}.</Grid>
                            <Grid xs={4}>
                              <FormControl fullWidth>
                                <InputLabel>&emsp;Predikat</InputLabel>
                                <Select
                                  label="Predikat"
                                  onChange={(e) => this.handleChange(e, index)}
                                  error={this.handleError(
                                    this.state.predikatFile[index]
                                  )}
                                  variant="outlined"
                                  // defaultValue={"memilikiADMIN1"}
                                  MenuProps={{
                                    anchorOrigin: {
                                      vertical: "bottom",
                                      horizontal: "left",
                                    },
                                    getContentAnchorEl: null,
                                    style: { maxHeight: 500 },
                                    // disableScrollLock: true
                                  }}
                                >
                                  {this.state.predikatList.map((item) => (
                                    <MenuItem
                                      value={this.handlePredikat(
                                        item.namaprediket
                                      )}
                                    >
                                      {item.labelprediket}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid xs={1} />
                            <Grid xs={4}>
                              <TextField
                                fullWidth
                                label="filename"
                                variant="outlined"
                                value={this.state.fileName[index]}
                                onChange={(e) =>
                                  this.handleChangeName(e, index)
                                }
                              />
                              {/* <h5>
                                {index + 1}. {item.name}
                              </h5> */}
                            </Grid>
                          </Grid>
                          <br />
                          <br />
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                </Grid>
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={3}>
                    {this.state.files.length === 0 ? null : (
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#497ac2",
                          color: "#FFF",
                          marginTop: "20px",
                          outline: "none",
                        }}
                        onClick={() => this.handelSubmit()}
                      >
                        Upload
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Dialog
                open={this.state.openWarning}
                onClose={() => this.setState({ openWarning: false })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Upload RDF</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Apakah anda yakin ingin mengupload file tersebut?
                  </DialogContentText>
                  <DialogActions>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#497ac2",
                        color: "#FFF",
                        outline: "none",
                      }}
                      onClick={this.handleUpload}
                    >
                      Ya
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        outline: "none",
                      }}
                      onClick={() => this.setState({ openWarning: false })}
                    >
                      Tidak
                    </Button>
                  </DialogActions>
                </DialogContent>
              </Dialog>
              <div className="container">
                <div className="row justify-content-center" id="counter" />
              </div>
              <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              {/* <Snackbar
              open={this.state.alert}
              autoHideDuration={4000}
              onClose={() => this.setState({ alert: false })}
              anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
              <Alert severity="success" variant="filled" style={{ width: 300 }}>
                Berhasil upload file
              </Alert>
            </Snackbar>
            <Snackbar
              open={this.state.alertError}
              autoHideDuration={4000}
              onClose={() => this.setState({ alertError: false })}
              anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            >
              <Alert severity="error" variant="filled" style={{ width: 300 }}>
                Gagal upload
              </Alert>
            </Snackbar> */}
            </div>
          </section>
          <TableUpload
            loadingTrue={this.handleLoadingTrue}
            loadingFalse={this.handleLoadingFlase}
            handleSuccess={this.handleSuccess}
          />
        </BlockUi>
      </AUX>
    );
  }
}

export default UploadRDF;
